module.exports = __webpack_public_path__ + "img/Comair.6955eb15.png";